import { useUpload } from '@/contexts/UploadContext';
import { Progress } from '@/components/ui/progress';
import { Upload, Check, AlertCircle, Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function UploadProgress() {
  const { uploads } = useUpload();

  if (uploads.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 w-80 space-y-2">
      {uploads.map((upload) => (
        <div
          key={upload.id}
          className={cn(
            "bg-card border rounded-lg p-3 shadow-lg transition-all",
            upload.status === 'complete' && "border-green-500/50",
            upload.status === 'error' && "border-destructive/50"
          )}
        >
          <div className="flex items-center gap-2 mb-2">
            {upload.status === 'compressing' && (
              <Loader2 className="h-4 w-4 animate-spin text-primary" />
            )}
            {upload.status === 'uploading' && (
              <Upload className="h-4 w-4 text-primary" />
            )}
            {upload.status === 'complete' && (
              <Check className="h-4 w-4 text-green-500" />
            )}
            {upload.status === 'error' && (
              <AlertCircle className="h-4 w-4 text-destructive" />
            )}
            <span className="text-sm font-medium truncate flex-1">
              {upload.fileName}
            </span>
          </div>
          
          {(upload.status === 'uploading' || upload.status === 'compressing') && (
            <>
              <Progress value={upload.progress} className="h-2" />
              <div className="flex justify-between text-xs text-muted-foreground mt-1">
                <span>
                  {upload.status === 'compressing' ? 'Compressing...' : 'Uploading...'}
                </span>
                <span>{upload.progress}%</span>
              </div>
            </>
          )}
          
          {upload.status === 'complete' && (
            <span className="text-xs text-green-500">Upload complete!</span>
          )}
          
          {upload.status === 'error' && (
            <span className="text-xs text-destructive">Upload failed</span>
          )}
        </div>
      ))}
    </div>
  );
}
